// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.HBj7_zF4sw {
  width: 369px;
  padding: 4px;
  box-shadow: 0 0 2px 2px rgba(0, 0, 0, 0.06);
  float: left;
  background: #fff;
}
.HBj7_zF4sw h4 {
  line-height: 3em;
}
.HBj7_zF4sw .lOhU9k2srK {
  float: left;
  width: 100%;
}
.HBj7_zF4sw .aGa1OVQREy {
  height: 40px;
  width: 60px;
  float: left;
  display: inline-block;
  min-height: 0;
  border-radius: 0;
  margin-bottom: 0;
  position: relative;
}
.HBj7_zF4sw .aGa1OVQREy:hover {
  cursor: pointer;
}
.HBj7_zF4sw .aGa1OVQREy:hover:after {
  position: absolute;
  content: "";
  z-index: 10;
  height: 40px;
  width: 60px;
  top: 0;
  left: 0;
  background: rgba(255, 255, 255, 0.3);
}
.WHJHLZ7Lq_ .IQfLqh2FQn:focus {
  outline: none;
}
.WHJHLZ7Lq_ .IQfLqh2FQn.uXTekHMaVe.jH9hTrbEFI {
  background: #375A88;
}
.WHJHLZ7Lq_ .IQfLqh2FQn.uXTekHMaVe.jH9hTrbEFI span {
  color: #fff;
}
.WHJHLZ7Lq_ .jH9hTrbEFI {
  background: #F5F4F9;
  border: 1px solid rgba(0, 0, 0, 0.06);
  color: rgba(0, 0, 0, 0.2);
}
.WHJHLZ7Lq_ .jH9hTrbEFI:hover {
  background: #4F5157;
  color: #fff;
  border: 1px solid rgba(0, 0, 0, 0.06);
}
.WHJHLZ7Lq_ input {
  height: 38px;
  min-width: 220px;
}
.aGa1OVQREy.oaVUAUl5qu {
  background: #410102;
}
.aGa1OVQREy.YQ35h8gqGp {
  background: #911318;
}
.aGa1OVQREy.SZrzKmQQMi {
  background: #D8293B;
}
.aGa1OVQREy.WHbRPwETFO {
  background: #F2373C;
}
.aGa1OVQREy.Yy_7z6ZpHX {
  background: #FC4448;
}
.aGa1OVQREy.ZCEGVIgMA6 {
  background: #ED535E;
}
.aGa1OVQREy.ZjfNDfH_nV {
  background: #E34926;
}
.aGa1OVQREy.wvZx6HaWSD {
  background: #FC562B;
}
.aGa1OVQREy.SqpxxLu4qq {
  background: #FC6722;
}
.aGa1OVQREy.RhmgLLr89G {
  background: #FD7F24;
}
.aGa1OVQREy.Wl6hoGli0g {
  background: #FD8D26;
}
.aGa1OVQREy.sJ_exaFSam {
  background: #EC9C3E;
}
.aGa1OVQREy.C6RUQE6CTy {
  background: #0e673a;
}
.aGa1OVQREy.nUl5OMXtZ0 {
  background: #208740;
}
.aGa1OVQREy.WQBZSTu_rV {
  background: #239718;
}
.aGa1OVQREy.JDJNQ9OgIK {
  background: #55A84D;
}
.aGa1OVQREy.cTWFvuagEG {
  background: #4BBE5A;
}
.aGa1OVQREy.g0V9TK9HWJ {
  background: #0CCA6A;
}
.aGa1OVQREy.xDYjROSSc0 {
  background: #0A3C64;
}
.aGa1OVQREy.srbyrYUiP0 {
  background: #0d487a;
}
.aGa1OVQREy.QqYc2dLl0n {
  background: #10538d;
}
.aGa1OVQREy.lVMytsDqET {
  background: #115A99;
}
.aGa1OVQREy.AsjNML6OWr {
  background: #3387E2;
}
.aGa1OVQREy.wDu0FXBKD3 {
  background: #1BA9CF;
}
.aGa1OVQREy.mqXrbKYXDJ {
  background: #d27c02;
}
.aGa1OVQREy.d8ymENYJHR {
  background: #fb9402;
}
.aGa1OVQREy.Glvdo3T0Al {
  background: #FD9B30;
}
.aGa1OVQREy.lAaPsSLaSn {
  background: #FDBE2D;
}
.aGa1OVQREy.SudwwUArd7 {
  background: #FED831;
}
.aGa1OVQREy.D2Lf89YoQV {
  background: #FFFD38;
}
.aGa1OVQREy.zMNJPbnR8c {
  background: #2D215C;
}
.aGa1OVQREy.zHZn2L4zi1 {
  background: #483C83;
}
.aGa1OVQREy.QlPRMYd6PN {
  background: #58518d;
}
.aGa1OVQREy.BDOgzwkp8k {
  background: #7068A9;
}
.aGa1OVQREy.CcmAuYMh40 {
  background: #7f78b2;
}
.aGa1OVQREy.W3OnMjMWbU {
  background: #8f88bc;
}
.aGa1OVQREy.fU1oNWFGzB {
  background: #000;
}
.aGa1OVQREy.oY7QaDjrGC {
  background: #282626;
}
.aGa1OVQREy.h9Ocw3qqTe {
  background: #242222;
}
.aGa1OVQREy.FIJRVN3vht {
  background: #353838;
}
.aGa1OVQREy.kEgJffyU0Q {
  background: #666;
}
.aGa1OVQREy.iP6rRwvWBU {
  background: #999;
}
.UHqX0OKP5e {
  background: none;
  margin-top: 120px;
  position: relative;
  margin-left: 10px;
}
.UHqX0OKP5e .NjYl4kX6dA {
  display: none;
}
._cZUPl2zIr {
  display: flex;
  height: 40px;
  margin-top: 20px;
}
._cZUPl2zIr .ApcshK96jr {
  align-items: center;
  background-color: #FF9D11;
  border-radius: 4px 0px 0px 4px;
  color: #fff;
  display: flex;
  justify-content: center;
  width: 40px;
}
._cZUPl2zIr .i4G5LIrOCl {
  align-items: center;
  background-color: #FFEBCF;
  border-radius: 0px 4px 4px 0px;
  display: flex;
  font-size: 11px;
  height: 100%;
  margin: 0;
  padding-left: 12px;
  padding-right: 20px;
}
.BjknJ7OkYv {
  margin-top: 20px;
}
.DZKUfhvJ0J {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-column-gap: 12px;
  margin-bottom: 12px;
}
.DZKUfhvJ0J .rpQXFa66xQ .fa-chevron-down {
  display: none !important;
}
.DZKUfhvJ0J .rpQXFa66xQ .tippy-content {
  font-weight: normal;
  text-transform: initial;
}
.DZKUfhvJ0J .rpQXFa66xQ .FhNCNQaOIQ {
  font-size: 11px;
}
.DZKUfhvJ0J .rpQXFa66xQ .FhNCNQaOIQ i {
  font-size: 11px;
  color: black;
}
.DZKUfhvJ0J .rpQXFa66xQ .Lq3GjcU_nM {
  margin-top: 4px;
}
.DZKUfhvJ0J .rpQXFa66xQ .Lq3GjcU_nM .N1BxSrZceZ {
  background-color: #fff;
}
.DZKUfhvJ0J .rpQXFa66xQ .Lq3GjcU_nM .N1BxSrZceZ .TAC872FiT7 {
  background-color: #f5f6fa;
  max-height: 21px;
  margin: 0;
}
.DZKUfhvJ0J .rpQXFa66xQ .FEs5MOpHNt .pulse-icon-button__ctn {
  display: none;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"color-picker": `HBj7_zF4sw`,
	"color-row": `lOhU9k2srK`,
	"color-tile": `aGa1OVQREy`,
	"picker-component": `WHJHLZ7Lq_`,
	"picker-element": `IQfLqh2FQn`,
	"active": `uXTekHMaVe`,
	"btn": `jH9hTrbEFI`,
	"red-1": `oaVUAUl5qu`,
	"red-2": `YQ35h8gqGp`,
	"red-3": `SZrzKmQQMi`,
	"red-4": `WHbRPwETFO`,
	"red-5": `Yy_7z6ZpHX`,
	"red-6": `ZCEGVIgMA6`,
	"orange-1": `ZjfNDfH_nV`,
	"orange-2": `wvZx6HaWSD`,
	"orange-3": `SqpxxLu4qq`,
	"orange-4": `RhmgLLr89G`,
	"orange-5": `Wl6hoGli0g`,
	"orange-6": `sJ_exaFSam`,
	"green-1": `C6RUQE6CTy`,
	"green-2": `nUl5OMXtZ0`,
	"green-3": `WQBZSTu_rV`,
	"green-4": `JDJNQ9OgIK`,
	"green-5": `cTWFvuagEG`,
	"green-6": `g0V9TK9HWJ`,
	"blue-1": `xDYjROSSc0`,
	"blue-2": `srbyrYUiP0`,
	"blue-3": `QqYc2dLl0n`,
	"blue-4": `lVMytsDqET`,
	"blue-5": `AsjNML6OWr`,
	"blue-6": `wDu0FXBKD3`,
	"yellow-1": `mqXrbKYXDJ`,
	"yellow-2": `d8ymENYJHR`,
	"yellow-3": `Glvdo3T0Al`,
	"yellow-4": `lAaPsSLaSn`,
	"yellow-5": `SudwwUArd7`,
	"yellow-6": `D2Lf89YoQV`,
	"purple-1": `zMNJPbnR8c`,
	"purple-2": `zHZn2L4zi1`,
	"purple-3": `QlPRMYd6PN`,
	"purple-4": `BDOgzwkp8k`,
	"purple-5": `CcmAuYMh40`,
	"purple-6": `W3OnMjMWbU`,
	"black-1": `fU1oNWFGzB`,
	"black-2": `oY7QaDjrGC`,
	"black-3": `h9Ocw3qqTe`,
	"black-4": `FIJRVN3vht`,
	"black-5": `kEgJffyU0Q`,
	"black-6": `iP6rRwvWBU`,
	"picker-theme": `UHqX0OKP5e`,
	"arrow-regular": `NjYl4kX6dA`,
	"template-settings-modal__info": `_cZUPl2zIr`,
	"template-info__icon": `ApcshK96jr`,
	"template-info__message": `i4G5LIrOCl`,
	"template-settings-modal__select": `BjknJ7OkYv`,
	"template-settings-modal__select--row": `DZKUfhvJ0J`,
	"permission-select__container": `rpQXFa66xQ`,
	"permission-title": `FhNCNQaOIQ`,
	"permission-select__users-view": `Lq3GjcU_nM`,
	"permission-select__select-container": `N1BxSrZceZ`,
	"user-permission-option": `TAC872FiT7`,
	"select-user__selectOptionLabel--hideRemoveIcon": `FEs5MOpHNt`
};
export default ___CSS_LOADER_EXPORT___;
